import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {authFormService} from "../../../../services/AuthFormService";
import {Messages} from "../../../../Messages";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NewsletterSubscribePanelStyle} from "./NewsletterSubscribePanel";
import {BasePanelPage} from "../BasePanelPage";
import {userService} from "../../../../../client/connection/Services";
import {MessageElement} from "../../../../widget/ui/MessageElement";


class NewsletterSubscribeSuccessPanelStyle extends NewsletterSubscribePanelStyle {
    @styleRule
    center = {
        textAlign: "center",
    };

    @styleRule
    title = this.themeProps.PAYWALL_TITLE;
}

@registerStyle(NewsletterSubscribeSuccessPanelStyle)
export class NewsletterSubscribeSuccessPanel extends BasePanelPage {
    widthValue = 420;

    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.title}>{Messages.newsletterSubscribeSuccessTitle(iFrameMerchantService.getMerchant().getName())}</div>,
            <MessageElement className={styleSheet.message} message={Messages.newsletterSubscribeSuccessText(authFormService.registrationMail || userService.getUserEmail())} />,
        ];
    }
}
